/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const SendMessage: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
      d="M11.2322 4.23223C11.6228 3.84171 12.3772 3.84171 12.7678 4.23223L18.7678 10.2322C19.1583 10.6228 19.1583 11.3772 18.7678 11.7678C18.3772 12.1583 17.6228 12.1583 17.2322 11.7678L13 7.53553V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V7.53553L6.76777 11.7678C6.37724 12.1583 5.62276 12.1583 5.23223 11.7678C4.84171 11.3772 4.84171 10.6228 5.23223 10.2322L11.2322 4.23223Z" />
  </svg>
}
